import { useEffect } from 'react'
import { useAuth0 } from './auth-provider'

export const Logout = () => {
  const { logout } = useAuth0()
  const handleLogout = () => {
    const event = new CustomEvent('LOGOUT_EVENT')
    window.dispatchEvent(event)
    localStorage.removeItem('token')
    localStorage.removeItem('headers')
    localStorage.removeItem('UI_CONFIG')
    localStorage.removeItem('sub')
    localStorage.removeItem('isTesting')
    localStorage.removeItem('x-organization-code')
    logout()
  }
  useEffect(() => {
    handleLogout()
  }, [])
  return <div></div>
}
